import { createContext } from 'react';

interface TradsContextType {
  translate:(text: string | undefined) => string;
  lang: string,
  setLang:(lang:string)=>void,
  tradsCache:Record<string,string>
  loaded:boolean,
  setLoaded:(loader:boolean)=>void
}

const TradsContext = createContext<TradsContextType | undefined>(undefined);
export default TradsContext;